_getEverFlowScript